import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import pOtpAl from '../../../../api/models/pOtpAl';
import rOtp from '../../../../api/models/rOtp';

export default ApiBaseReducer<pOtpAl, IInputDataStateModel<pOtpAl, rOtp>, rOtp>(
  ActionSubTypes.API_OTPAL,
  DefaultInputDataStateModel<pOtpAl, rOtp>()
);
